export default __webpack_public_path__ + "static/hero-image-6-2d2a5069d15e18431761b4a74be2d59f.png";